import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDepartmentsRequest } from '../services/surveys';

export const useDepartmentsLookup = (isEffect: boolean) => {
  const params = useParams();
  const surveyId = params.surveyId || '1';
  const [departmentsMap, setDepartmentsMap] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!isEffect) {
      setDepartmentsMap({});
      return;
    }

    let cancelled = false;

    const fetchAllDepartments = async () => {
      const map: Record<string, string> = {};
      let pageNo = 1;
      let totalPages = 1;

      try {
        while (pageNo <= totalPages && !cancelled) {
          const response = await getDepartmentsRequest(surveyId, { pageNo, perPage: 100 });
          response.items.forEach(dept => {
            map[dept.id] = dept.name;
          });
          totalPages = response.pagingInfo.totalPageCount || 1;
          pageNo += 1;
        }

        if (!cancelled) {
          setDepartmentsMap(map);
        }
      } catch {
        if (!cancelled) {
          setDepartmentsMap({});
        }
      }
    };

    fetchAllDepartments();

    return () => {
      cancelled = true;
    };
  }, [surveyId, isEffect]);

  return departmentsMap;
};
